import clsx from 'clsx';
import type { AlertFeedConnection } from '../hooks/use-alert-feed';

const LABELS: Record<AlertFeedConnection, string> = { connecting: 'Connecting…', live: 'Live', reconnecting: 'Reconnecting…' };

/** Whether new alerts are arriving by themselves. Quiet: it only matters when it is not live, and then the list still works on reload. */
export function AlertFeedStatus({ connection }: { connection: AlertFeedConnection }) {
  return (
    <span role="status" className="inline-flex items-center gap-2 text-xs text-muted">
      <span aria-hidden className={clsx('size-2 rounded-full', connection === 'live' ? 'bg-success' : 'bg-warning')} />
      {LABELS[connection]}
    </span>
  );
}
